import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Otp.css";
import { auth } from "../../Utils/firebase";
import { PhoneAuthProvider, RecaptchaVerifier, signInWithCredential, signInWithPhoneNumber } from "firebase/auth";
import { gettoastsuccess, gettoastwarning, handleFirebaseError } from "../../Utils/Common";
import { useAuth } from "../../hooks/useAuth";
import CustomLoader from "../../components/CustomLoader";
import API from '../../Utils/Api';

const Otp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const routeData = location.state || {};
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [verificationId, setVerificationId] = useState(routeData?.verificationId);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  //const [inputs, setInputs] = useState({ ...routeData });
  const [inputs] = useState({ ...routeData });
  const [resending, setResending] = useState(false);
  const [timer, setTimer] = useState(30);

  // Handle OTP input
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    let newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Auto focus next
    if (element.nextSibling && element.value !== "") {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      e.target.previousSibling.focus();
    }
  };

  const verifyOtp = async () => {
    if (!verificationId) {
      gettoastwarning("Missing verification ID");
      return;
    }
    const otpCode = otp.join("");
    if (!otpCode) {
      gettoastwarning("Please enter the OTP");
      return;
    }
    if (otpCode.length !== 6) {
      gettoastwarning("Invalid OTP");
      return;
    }
    setLoading(true);
    try {
      
      const credential = PhoneAuthProvider.credential(verificationId, otpCode);

      await signInWithCredential(auth, credential);

      // console.log("User verified:", userCredential.user);
      if (inputs?.origin === 'signup') {
        doSignUp();
      } else if (inputs?.origin === 'forgot_password') {
        setLoading(false);
        navigate("/reset-password/", { replace: true, state: { id: inputs?.id } });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error verifying OTP:", error);
      handleFirebaseError(error)
    }
  };
  const doSignUp = async () => {
    setLoading(true);
    let error;
    try {
      const formInputs = { ...inputs, is_submit: 1 }
      console.log('signup inputs', formInputs);
      API.post('register_masterclass', formInputs)
        .then(response => {
          setLoading(false);
          const apiResponse = response.data;
          console.log('signup response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            if(localStorage.getItem('prev_page'))
            {
              gettoastsuccess(response.data.message, localStorage.getItem('prev_page'), 1000);
            }else{
              gettoastsuccess(response.data.message, '/dating-masterclass', 1000);
            }
            login(apiResponse?.data?.token)
          }
        }).catch(e => {
          error = e.message;
          console.log('signup error1', error);
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      console.log('signup error2', error);
      gettoastwarning(error);
    }
  };
  /* Resend OTP */
  const setupRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      {
        size: "invisible",
        callback: () => console.log("reCAPTCHA verified"),
      }
    );
  };
  const resendOtp = async () => {
    setLoading(true);
    try {
      setResending(true);
      setupRecaptcha();
      const appVerifier = window.recaptchaVerifier;
      const phoneNumber = inputs.country_code + inputs.mobile_number
      const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      const verificationId = confirmationResult.verificationId;
      setVerificationId(verificationId);
      setLoading(false);
      gettoastsuccess('OTP Resent!', '', 3000);
    } catch (error) {
      setLoading(false);
      console.log("SMS not sent", error?.message);
      handleFirebaseError(error,'',navigate)
    }finally {
      setResending(false);
    }
  }
  useEffect(() => {
  if (timer > 0) {
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }
}, [timer]);
  useEffect(() => {
    document.title = `Otp | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'otp';
  }, []);

  return (
    <>
      <CustomLoader loading={loading} />
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 lo-oma position-relative">
        <div className="back-btn d-flex gap-1" onClick={() => navigate(-1)}>
          <img
            src={process.env.REACT_APP_BASE_URL + "assests/images/left-frame.png"}
            alt="back"
            className="img-fluid"
          />
          back
        </div>
        <div className="row w-100 my-5">
          <div className="col-md-6 col-lg-4 mx-auto">

            <div className="p-2">
              <h3 className="text-center">OTP verification</h3>
              <p className="text-center omas-p mb-0">Please enter the 6-digit code that has been</p>
              <p className="text-center omas-p niku">sent to {inputs?.full_mobile_number}.</p>

              {/* OTP Boxes */}
              <div className="d-flex justify-content-between mb-3 otp-inputs">
                {otp.map((data, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    className="form-control text-center otp-box"
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onFocus={(e) => e.target.select()}
                  />
                ))}
              </div>

              {/* Resend link */}
              <p className="text-center resend">
                Didn’t receive a code?{" "}
                <Link to="" className={`resend-link ${(timer > 0 || resending) && 'text-decoration-none disable-link'}`} onClick={resendOtp}>{timer > 0 ? `Resend in ${timer}s` : "Resend"}</Link>
              </p>

              {/* Login button */}
              <div className="d-grid mb-3 text-center">
                {/* <Link to="" className="logus-in text-decoration-none" onClick={verifyOtp}>Submit</Link> */}
                <button className="logus-in" type="button" onClick={verifyOtp}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="recaptcha-container"></div>
    </>
  );
};

export default Otp;
